import React from 'react';
import clsx from 'clsx';

export const FooterSection = ({ title, children, className = '' }) => (
  <div className={clsx('', className)}>
    <h3 className="text-lg font-semibold mb-4 text-white">
      {title}
    </h3>
    <ul className="space-y-3">
      {children}
    </ul>
  </div>
);